import { Component, Inject, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFireAuth } from '@angular/fire/auth';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
 
@Component({
  selector: 'app-user-roles',
  templateUrl: './user-roles.component.html',
  styleUrls: ['./user-roles.component.css']
})
export class UserRolesComponent implements OnInit {

  constructor(
    public functions: AngularFireFunctions,
    public fb: FormBuilder,
    public afAuth: AngularFireAuth,
    public dialogRef: MatDialogRef<UserRolesComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  usuario = JSON.parse(localStorage.getItem("user"));
  token = JSON.parse(localStorage.getItem("token"));
  adminForm: FormGroup;
  instructorForm: FormGroup;
  adminEmail: string;
  instructorEmail: string;
  privilegio: string = null;

  ngOnInit(): void {
    if (this.token) {
      if (this.token != 'superadmin') {
        this.router.navigate(['']);
      } else {
        if (this.data) {
          this.adminEmail = this.data.email;
          this.privilegio = this.data.privilegio;
       
        } else {
          this.adminEmail = ""
        } 
      }
    } else {
      this.router.navigate(['']);
    }
       
  }

  async makeAdmin(role) {
    const adminEmail = this.adminEmail;    
    await this.functions.httpsCallable('eliminarRole')({ email: adminEmail }).toPromise()
    await this.functions.httpsCallable('addAdminRole')({ email: adminEmail, role: role }).toPromise()
    alert("admin creado con nuevo role")
    this.dialogRef.close(true);
  }

  makeInstructor() {
    const instructorEmail = this.instructorEmail;
    console.log('entre')
    console.log(instructorEmail);
    const addInstructorRole = this.functions.httpsCallable('addInstructorRole');
    addInstructorRole({ email: instructorEmail })
  }

}
